export default __webpack_public_path__ + "static/media/Instagram.925fd433.svg";